<div
    id="trainers-details-container"
    class="trainer container"
    *ngIf="currentTrainer"
>
    <div class="experiences limiter">
        <h3>{{ 'trainer-detail.experiences' | translate }}</h3>
        <div class="skills">
            <div class="list-skills">
                <label-skill
                    [mustDisplayGiven]="true"
                    [skills]="items"
                ></label-skill>
            </div>
        </div>
    </div>
    <div class="formations">
        <h3></h3>
        <div class="types">
            <div class="type">
                <span class="title">{{
                    'trainer-detail.followed' | translate
                }}</span>
                <div class="skills">
                    <div class="list-skills">
                        <label-skill
                            [mustDisplayFollowed]="true"
                            [skills]="items"
                        ></label-skill>
                    </div>
                </div>
            </div>
            <div class="type" (click)="selectedBox = 'wished'">
                <span class="title">{{
                    'trainer-detail.wished' | translate
                }}</span>
                <div class="skills">
                    <div class="list-skills">
                        <label-skill
                            [mustDisplayWished]="true"
                            [editable]="canEditWishes"
                            [skills]="items"
                            (deleteSkill)="deleteSkill($event)"
                        ></label-skill>
                    </div>
                </div>
            </div>
            <div class="type" (click)="selectedBox = 'can'">
                <span class="title">{{
                    'trainer-detail.can' | translate
                }}</span>
                <div class="skills">
                    <div class="list-skills">
                        <label-skill
                            [mustDisplayCan]="true"
                            [editable]="canEditCan"
                            [skills]="items"
                            (deleteSkill)="deleteSkill($event)"
                        ></label-skill>
                    </div>
                </div>
            </div>
            <div class="type" (click)="selectedBox = 'refuse'">
                <span class="title">{{
                    'trainer-detail.refuse' | translate
                }}</span>
                <div class="skills">
                    <div class="list-skills">
                        <label-skill
                            [mustDisplayRefuse]="true"
                            [editable]="canEditWishes"
                            [skills]="items"
                            (deleteSkill)="deleteSkill($event)"
                        ></label-skill>
                    </div>
                </div>
            </div>
        </div>
        <div class="filters" *ngIf="canEditWishes">
            <!-- Those modifications are restricted to ADMIN-->
            <div class="form-group skill">
                <label class="control-label" for="skill-filter">{{
                    'trainer-detail.training' | translate
                }}</label>
                <input
                    auto-complete
                    [(ngModel)]="selectedTraining"
                    [source]="searchTrainings.bind(this)"
                    [list-formatter]="myListFormatter"
                    id="skill-filter-admin"
                    class="form-control"
                    [accept-user-input]="false"
                    [min-chars]="1"
                    [max-num-list]="14"
                    display-property-name="title"
                    autocomplete="off"
                />
            </div>
            <div class="form-group block">
                <label class="control-label" for="company-filter">{{
                    'trainer-detail.block' | translate
                }}</label>
                <select
                    class="form-control"
                    id="company-filter-admin"
                    type="text"
                    [(ngModel)]="selectedBox"
                >
                    <option value="wished">{{
                        'trainer-detail.wished' | translate
                    }}</option>
                    <option
                        value="can"
                        *jhiHasAnyAuthority="'ROLE_RESPONSABLE_PEDAGOGIQUE'"
                        >{{ 'trainer-detail.can' | translate }}</option
                    >
                    <option value="refuse">{{
                        'trainer-detail.refuse' | translate
                    }}</option>
                </select>
            </div>
            <div class="bouton">
                <button (click)="addSkill()" [disabled]="saving" class="btn btn-zenika">
                    <span *ngIf="saving" class="fa fa-spinner fa-spin"></span>
                    Ajouter
                </button>
            </div>
        </div>
    </div>
    &nbsp;
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/trainer/detail/skill/skill.component.html